import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/SiteDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class SiteEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/site"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/site/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/site/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/site/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/site/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/site/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/site/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class SiteFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public name: IFieldOptions = { field: "name" };
	public prefix: IFieldOptions = { field: "prefix" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedBy: IFieldOptions = { field: "changedBy" };
	public status: IFieldOptions = { field: "status" };
	public address: IFieldOptions = { field: "address" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.name);
		this.push(this.prefix);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.status);
		this.push(this.address);
	}
}

export class SiteForm implements IFormOptions {
	protected siteFormName: string = "siteForm";
	protected siteFormModel: models.SiteDTO = new models.SiteDTO();
	protected siteFormEndPoints: SiteEndPoints = new SiteEndPoints();
	protected siteFormFields: SiteFormFields = new SiteFormFields();
	public get name(): string { return this.siteFormName };
	public get model(): models.SiteDTO { return this.siteFormModel };
	public get endPoints(): IEntityEndPoints { return this.siteFormEndPoints };
       public set endPoints(siteEndPoints: IEntityEndPoints) {
		this.siteFormEndPoints = siteEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): SiteFormFields { return this.siteFormFields };
}

export class SiteListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public name: IColumnOptions = { field: "name" };
	public prefix: IColumnOptions = { field: "prefix" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedBy: IColumnOptions = { field: "changedBy" };
	public status: IColumnOptions = { field: "status" };
	public address: IColumnOptions = { field: "address" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.name);
		this.push(this.prefix);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.status);
		this.push(this.address);
	}
}

export class SiteList implements IGridOptions {
	protected siteListName: string = "siteList";
	protected siteListModel: models.SiteDTO = new models.SiteDTO();
	protected siteListEndPoints: SiteEndPoints = new SiteEndPoints();
	protected siteListColumns: SiteListColumns = new SiteListColumns();
	public siteForm: SiteForm = new SiteForm();
	public get name(): string { return this.siteListName };
	public get model(): models.SiteDTO { return this.siteListModel };
	public get endPoints(): IEntityEndPoints { return this.siteListEndPoints };
	public set endPoints(siteEndPoints: IEntityEndPoints) {
		this.siteListEndPoints = siteEndPoints;
		this.siteForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): SiteListColumns { return this.siteListColumns };
}

export class SiteEntity implements IEntityOptions {
	protected siteEntityName: string = "siteEntity";
	protected siteEntityModel: models.SiteDTO = new models.SiteDTO();
	protected siteEntityEndPoints: SiteEndPoints = new SiteEndPoints();
	protected siteEntityList: SiteList = new SiteList();
	public get name(): string { return this.siteEntityName };
	public get model(): models.SiteDTO { return this.siteEntityModel };
	public get endPoints(): IEntityEndPoints { return this.siteEntityEndPoints };
	public set endPoints(siteEndPoints: IEntityEndPoints) {
		this.siteEntityEndPoints = siteEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): SiteList { return this.siteEntityList };
	public get form(): SiteForm { return this.grid.siteForm };
	constructor(name?: string) {
		if (name) this.siteEntityName = name;
		this.endPoints = this.siteEntityEndPoints;
	}
};
//export class SiteGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: SiteForm = new SiteForm();
//};

//export class SiteListPageComponent extends ListPageComponent {
  //protected listPageComponentList: SiteList = new  SiteList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class SiteBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: SiteGeneratedForm}];
//};

//export class SiteListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: SiteListPageComponent, isMenuHidden: true }];
//};

